export default __webpack_public_path__ + "static/media/emirates-identity-authority-seeklogo.com.e0efd06c.svg";